export default "/images/850faf8ead49461c318959babff54a70.png";